import { AppAside } from "@/app-shell";
import { DemoAiScriptExplanationChatSidebar } from "@/payroll/ai-script/ai-script-explanation-chat/demo-ai-script-explanation-chat-sidebar";
import { AiScriptExplanationChatSidebar } from "@/payroll/ai-script/ai-script-explanation-chat-sidebar";
import { PAY_BREAKDOWN_RUN_TARGET_TYPE } from "@/payroll/pay-breakdown/types";
import type { PayBreakdownPageState } from "./use-pay-breakdown-page";

interface PayBreakdownExplanationAsideProps {
  page: PayBreakdownPageState;
}

export const PayBreakdownExplanationAside = ({
  page,
}: PayBreakdownExplanationAsideProps) => {
  const {
    businessId,
    appEnv,
    output,
    pendingQuestion,
    setPendingQuestion,
    isExplanationChatOpen,
    setIsExplanationChatOpen,
    selectionContext,
    spreadsheetViewerRef,
  } = page;

  return (
    <AppAside
      open={
        isExplanationChatOpen &&
        output.type === PAY_BREAKDOWN_RUN_TARGET_TYPE.aiScript
      }
    >
      {output.type === PAY_BREAKDOWN_RUN_TARGET_TYPE.aiScript &&
        (appEnv === "demo" ? (
          <DemoAiScriptExplanationChatSidebar
            key={output.runId}
            selectionContext={selectionContext}
            pendingQuestion={pendingQuestion}
            onQuestionPrepared={() => setPendingQuestion(null)}
            onClearSelectionContext={() =>
              spreadsheetViewerRef.current?.clearSelection()
            }
            onClose={() => setIsExplanationChatOpen(false)}
          />
        ) : (
          <AiScriptExplanationChatSidebar
            key={output.runId}
            businessId={businessId}
            runId={output.runId}
            selectionContext={selectionContext}
            pendingQuestion={pendingQuestion}
            onQuestionPrepared={() => setPendingQuestion(null)}
            onClearSelectionContext={() =>
              spreadsheetViewerRef.current?.clearSelection()
            }
            onClose={() => setIsExplanationChatOpen(false)}
          />
        ))}
    </AppAside>
  );
};
